/**
 * Surveillance left-panel root.
 *
 * Mockup `lp-surv-list` vs `lp-surv-detail` swap (L2018 / L3340):
 *   - Fused mode → show service list (`SurvList`).
 *   - Diagnostic mode → show detail for `selectedNetwork`
 *     (auto-selected to Live_MLAT by the store, mockup setSurvMode L9770).
 */
import { useSurvStore } from '@/lib/store/surv';
import { FUSED_TRACKS_ID } from '@/lib/surv/fusedSummary';
import { FusedTracksDetail } from './FusedTracksDetail';
import { SurvList } from './SurvList';
import { SurvDetail } from './SurvDetail';

export function SurvContext() {
  const mode = useSurvStore((s) => s.mode);
  const selectedNetwork = useSurvStore((s) => s.selectedNetwork);

  if (mode === 'diagnostic' && selectedNetwork === FUSED_TRACKS_ID) return <FusedTracksDetail />;
  if (mode === 'diagnostic' && selectedNetwork) {
    return <SurvDetail id={selectedNetwork} />;
  }
  return <SurvList />;
}
